const plugin = {
  install: function (Vue, options) {
    window.addEventListener("scroll", function (e) {
      checkElements()
    });

    // if (options.router){
    //   options.router.beforeEach((to, from, next) => {
    //     checkElements()
    //     next()
    //   })
    // }

    Vue.directive('scrolldetect', {
      // When the bound element is inserted into the DOM...
      bind: function (el, binding, vnode) {
        addDetectedElement(el, binding)
        checkElements()
      },
      unbind: function (el, binding, vnode) {
        removeDetectedElement(el)
      }
    })
  }
}

let lastKnownScrollPos = 0;
const
  detectedElements = [],
  eventListeners = []
;

export const addScrollEventListener = function (fn) {
  eventListeners.push(fn)
}

export const removeScrollEventListener = function (fn) {
  const index = eventListeners.indexOf(fn);
  if (index !== -1) eventListeners.splice(index, 1);
}

export const addDetectedElement = function (el, binding) {
  detectedElements.push({el, binding})
}

export const removeDetectedElement = function (el) {
  let index = null;

  detectedElements.forEach((option, idx) => {
    if (option.el === el) index = idx
  })

  if (index !== null) detectedElements.splice(index, 1);
}

function checkElements() {
  const
    newScrollPos = window.scrollY,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop
  ;

  detectedElements.forEach((option) => {
    const e = option.el;
    let
      elScrollTopNoOffset = e.getBoundingClientRect().top + scrollTop,
      offset = option.binding.value && option.binding.value.offset ? option.binding.value.offset : 0,
      elScrollTop = elScrollTopNoOffset + offset

    if (lastKnownScrollPos === elScrollTopNoOffset || (lastKnownScrollPos <= elScrollTop && newScrollPos > elScrollTop)) {
      triggerCallbacks({el : e, direction: 'down', binding : option.binding})
    } else if (lastKnownScrollPos >= elScrollTop && newScrollPos < elScrollTop) {
      triggerCallbacks({el : e, direction: 'up', binding : option.binding})
    }
  })

  lastKnownScrollPos = newScrollPos;
}

function triggerCallbacks(data){
  eventListeners.forEach((listener) => {
    listener(data)
  });
}

export default plugin